export enum UserNotificationTypeEnum {
  REMINDER = "REMINDER",
  OPERATIONAL_DEMAND = "OPERATIONAL_DEMAND",
  ORDER = "ORDER"
}
